import config from 'constants/config'

const LOYALTY_INCLUSIONS: App.LoyaltyMemberInclusion[] = [
  {
    id: 'credits',
    description: 'US$100 resort credit',
    iconType: 'hotel-credits',
  },
  {
    id: 'dailyBreakfast',
    description: 'Daily breakfast',
    iconType: 'daily-breakfast',
  },
  {
    id: 'roomUpgrade',
    description: 'Room Upgrade (Subject to Availability)',
    iconType: 'room-upgrade',
  },
]

const getLoyaltyInclusionTypes = (): App.LoyaltyMemberInclusionTypes | undefined => {
  if (!config.LUXURY_PLUS_ENABLED) return undefined

  // Return tiers of inclusions
  return {
    base: LOYALTY_INCLUSIONS,
  }
}

export const LOYALTY_INCLUSION_TYPES = getLoyaltyInclusionTypes()
